import { TOnboardingData } from '../../types/onboarding';
import { IApplicationState } from '../../types/redux';

/* istanbul ignore next */
export function selectTestOnboarding(state: IApplicationState): TOnboardingData | null {
  return state.onboarding;
}
